import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import {withRouter} from 'react-router-dom';
import MetisMenu from 'react-metismenu';
import {connect} from "react-redux";
import cx from 'classnames';
import {Button} from "reactstrap";
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import {buildStyles, CircularProgressbar} from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import moment from 'moment';

import {setEnableMobileMenu} from '../actions/ThemeOptions';
import {setUpgradeToPROModalOpen} from "../actions/Billing";
import {
    CHARGEBEE_SUBSCRIPTION_STATUS_IN_TRIAL,
    METIS_MENU_BILLING,
    METIS_MENU_CUSTOM_PREFIX,
    SHOP_SOURCE_CHAT_API,
    SHOP_SOURCE_HIGHTOUCH,
    SHOP_SOURCE_RETAIL_CRM_WABA_RU,
    SHOP_SOURCE_RETAIL_CRM_INSTAGRAM_RU,
} from "../constants";
import SimpleChat from "./AppHeader/Components/SimpleChat";

import {IonList, IonItem, IonIcon, IonLabel, IonMenuToggle} from '@ionic/react';
import {chevronBackOutline, settingsOutline, helpCircleOutline, bookmarkOutline, addOutline, personOutline, peopleOutline} from 'ionicons/icons';
import {revokeFirebaseToken} from "../thunks/Notifications";
import {setEnableMobileMenuSmall} from '../actions/ThemeOptions';
import {logoutRequestStart} from '../actions/Auth';
import {addingNewContactToggleModal,} from "../actions/Chats";
import AlertSelectShop from '../Components/ionic/AlertSelectShop';
import ImportContactsModal from "../Pages/Chats/Chats/modals/ImportContactsModal";
import NewContactModal from "../Pages/Chats/Chats/modals/NewContactModal";
import { App } from '@capacitor/app';


const _ExtendedLinkComponent = (
    {
        className,
        classNameActive,
        classNameHasActiveChild,
        active,
        hasActiveChild,
        to,
        externalLink,
        hasSubMenu,
        toggleSubMenu,
        activateMe,
        children,
        billingConfig,

        setUpgradeToPROModalOpen,
    }
) => {
    const customActivateMe = (event) => {
        /**
         * 1. Для внешних ссылок пункт меню не активируем
         * 2. Для ссылок-функций запускаем эти функции
         * 3. В остальных случаях оставляем стандартное поведение
         */
        if (to && to.startsWith(METIS_MENU_CUSTOM_PREFIX)) {
            switch (to) {
                case METIS_MENU_BILLING:
                    setUpgradeToPROModalOpen(true);
                    break;
            }

            event.preventDefault();
            return;
        } else if (externalLink) {
            return;
        }

        return activateMe(event);
    }

    return <a
        className={cx(
            className,
            active && classNameActive,
            hasActiveChild && classNameHasActiveChild,
        )}
        href={to && to.startsWith(METIS_MENU_CUSTOM_PREFIX) ? '#' : to}
        onClick={hasSubMenu ? toggleSubMenu : customActivateMe}
        target={externalLink ? '_blank' : undefined}
    >
        {children}
    </a>;
};

const mapState1ToProps = state => ({});

const mapDispatch1ToProps = dispatch => ({
    setUpgradeToPROModalOpen: open => dispatch(setUpgradeToPROModalOpen(open)),
});

const ExtendedLinkComponent = withRouter(connect(mapState1ToProps, mapDispatch1ToProps)(_ExtendedLinkComponent));


const Nav = (
    {

        user,
        currentShopAdministrator,
        activeShop,
        billingConfig,

        setEnableMobileMenu,
        setUpgradeToPROModalOpen,

        firebaseToken,
        revokeFirebaseToken,
        setEnableMobileMenuSmall,
        logoutRequestStart,

        addingNewContactToggleModal,
        shops,
    }
) => {
    let [navLinks, setNavLinks] = useState([]);
    const [alertSelectShopToggle, setAlertSelectShopToggle] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [version, setVersion] = useState("");

    useEffect(()=>{
      App.getInfo().then(data=>setVersion(data.version.toString())).catch(e=>{})
    })

    const {t, i18n} = useTranslation();

    const isChatApi = get(activeShop, 'source') === SHOP_SOURCE_CHAT_API;
    const isRetailCRM = (
        get(activeShop, 'source') === SHOP_SOURCE_RETAIL_CRM_WABA_RU
        || get(activeShop, 'source') === SHOP_SOURCE_RETAIL_CRM_INSTAGRAM_RU
    );
    const activeShopId = get(activeShop, 'id');




    const logout = () => {
        firebaseToken && revokeFirebaseToken(firebaseToken);
        setEnableMobileMenuSmall(false);
        setTimeout(() => logoutRequestStart(), 200);
    };



    return <><IonList mode="md" className="i-menu-list">
        <IonMenuToggle auto-hide="true">
            {/* <IonItem lines="none" button className="i-menu-list-item">
                <IonIcon icon={personOutline} className="i-menu-list-item-icon" />
                <IonLabel className="i-menu-list-item-label">
                    {t('menu.my_account', "My Account")}
                </IonLabel>
            </IonItem> */}
            <IonItem lines="none" button className="i-menu-list-item" onClick={() => {setShowModal(true)}}>
                <IonIcon icon={addOutline} className="i-menu-list-item-icon" />
                <IonLabel className="i-menu-list-item-label">
                    {t('menu.add_account', "Add Account")}
                </IonLabel>
            </IonItem>
            {
                currentShopAdministrator?.type !== 'operators' &&
                <IonItem lines="none" button className="i-menu-list-item" routerLink={`/${activeShopId}/settings/common/`}>
                    <IonIcon icon={settingsOutline} className="i-menu-list-item-icon" />
                    <IonLabel className="i-menu-list-item-label">
                        {t('menu.settings', "My settings")}
                    </IonLabel>
                </IonItem>
            }
            <IonItem lines="none" button className="i-menu-list-item" routerLink={`/${activeShopId}/settings/personal_settings/`}>
                <IonIcon icon={personOutline} className="i-menu-list-item-icon" />
                <IonLabel className="i-menu-list-item-label">
                    {t('menu.personal_settings', "Personal settings")}
                </IonLabel>
            </IonItem>
            {/* <IonItem lines="none" button className="i-menu-list-item">
                <IonIcon icon={bookmarkOutline} className="i-menu-list-item-icon" />
                <IonLabel className="i-menu-list-item-label">
                    {t('menu.saved_messages', "Saved Messages")}
                </IonLabel>
            </IonItem> */}
            {/* <IonItem lines="none" button href="https://help-lk.1msg.io/en/" target="_blank" className="i-menu-list-item">
                <IonIcon icon={helpCircleOutline} className="i-menu-list-item-icon" />
                <IonLabel className="i-menu-list-item-label">
                    {t('menu.help', "Help")}
                </IonLabel>
            </IonItem> */}
            <IonItem lines="none" button href="mailto:hello@1msg.io" target="_blank" className="i-menu-list-item"> {/* i-menu-list-item-active */}
                <IonIcon icon={helpCircleOutline} className="i-menu-list-item-icon" />
                <IonLabel className="i-menu-list-item-label">
                    {t('menu.сontact_support', "Contact Support")}
                </IonLabel>
            </IonItem>
            {
                shops.length > 1 &&
                <IonItem lines="none" button className="i-menu-list-item" onClick={() => setAlertSelectShopToggle(true)}>
                    <IonIcon icon={peopleOutline} className="i-menu-list-item-icon" />
                    <IonLabel className="i-menu-list-item-label">
                        {t('menu.change_the_cabinet', "Сhange The Cabinet")}
                    </IonLabel>
                </IonItem>
            }
        </IonMenuToggle>
    </IonList>
      <div className="menu-bottom">
        {version}
      </div>
    {
        shops.length > 1 &&
        <AlertSelectShop
            state={alertSelectShopToggle}
            setState={setAlertSelectShopToggle}
        />
    }
        {/* <ImportContactsModal/> */}
        <NewContactModal isOpen={showModal} setIsOpen={setShowModal}/>
    </>

}


const mapStateToProps = state => ({
    user: state.Auth.user,
    activeShop: state.Shops.activeShop,
    billingConfig: state.Billing.billingConfig,
    firebaseToken: state.Notifications.firebaseToken,
    shops: state.Shops.shops,
    currentShopAdministrator: state.Shops.currentShopAdministrator,
});

const mapDispatchToProps = dispatch => ({
    setEnableMobileMenu: enable => dispatch(setEnableMobileMenu(enable)),
    setUpgradeToPROModalOpen: open => dispatch(setUpgradeToPROModalOpen(open)),
    logoutRequestStart: () => dispatch(logoutRequestStart()),
    revokeFirebaseToken: (firebaseToken, callback) => dispatch(revokeFirebaseToken(firebaseToken, callback)),
    setEnableMobileMenuSmall: (enabled) => dispatch(setEnableMobileMenuSmall(enabled)),
    addingNewContactToggleModal: (bool) => dispatch(addingNewContactToggleModal(bool)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Nav));
